interface OOO {
  [key: string]: any;
}

export const filterNonNullProps = (obj: OOO) =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== null));
